import {
  TripResponse,
  TripStopResponse,
  VehicleStopPurpose,
  VehicleStopType,
  VehicleTripResponse,
} from "types/trip.types";
import { BaseResponse, PlaceResponse } from "types/responses.type";
import api from "./api";
import dayjs from "dayjs";
import { OrderResponse } from "types/order.types";

interface GetTripsParams {
  date: Date;
  page?: number;
  pageSize?: number;
  search?: string;
}

class TripsService {
  static async getUnassignedStops(params: { date: Date }) {
    const date = dayjs(params.date).format("YYYY-MM-DD");
    const response = await api.get(`/orders/unassigned/${date}`);
    const unassignedStops: TripStopResponse[] = [];
    let fakeTripStopId = 1;
    response.data?.data?.forEach((order: OrderResponse) => {
      let place: PlaceResponse | null = null;
      if (
        order.activityDeliveries?.length &&
        order.activityDeliveries[0].dropoffPlace
      ) {
        place = order.activityDeliveries[0].dropoffPlace;
      } else if (
        order.activityTransfers?.length &&
        order.activityTransfers[0].dropoffPlace
      ) {
        place = order.activityTransfers[0].dropoffPlace;
      } else {
        place = order.customer?.defaultPlace ?? null;
      }
      if (place) {
        const stopIdx = unassignedStops.findIndex(
          (s) => s.placeId == place?.placeId
        );
        if (stopIdx < 0) {
          unassignedStops.push({
            tripStopId: fakeTripStopId,
            customer: order.customer,
            orders: [order],
            place,
            placeId: place.placeId,
            status: "FAKE",
          });
          fakeTripStopId++;
        } else {
          unassignedStops[stopIdx].orders?.push(order);
        }
      }
    });
    return unassignedStops;
  }
  static async getUnassignedTrips(params: { date: Date }) {
    const date = dayjs(params.date).format("YYYY-MM-DD");
    const response = await api.get(`/trips/unassigned/${date}`);
    return response.data;
  }
  static async getTrips(
    params: GetTripsParams
  ): Promise<BaseResponse<VehicleTripResponse[]>> {
    const date = dayjs(params.date).format("YYYY-MM-DD");
    const response = await api.get(`/trips/vehicle-trips/${date}`);
    let colorIndex = 0;
    response.data.data?.forEach(
      (trip: VehicleTripResponse, tripIndex: number) => {
        response.data.data[tripIndex].additionalData = {
          ...trip.additionalData,
          colorIndex,
        };
        colorIndex++;

        let customerNumber = 1;
        trip.vehicleStops?.forEach((stop, stopIndex) => {
          if (stop.type === "CUSTOMER") {
            stop.additionalData = {
              stopLabel: `${customerNumber}`,
            };
            customerNumber++;
          }
        });
      }
    );
    return response.data;
  }

  static async getTrip(id: string): Promise<BaseResponse<TripResponse>> {
    const response = await api.get(`/trips/${id}`);
    return response.data;
  }
  static async updateVehicleStopTypeAndPurpose(
    vehicleStopId: number,
    data: { purpose?: VehicleStopPurpose | null; type?: VehicleStopType | null }
  ) {
    const response = await api.patch(`/vehicle-stops/${vehicleStopId}`, data);
    return response.data;
  }
}

export default TripsService;
